import { useGetLocale } from '@refinedev/core';
import { ThemeConfig } from 'antd';
import enUs from 'antd/lib/locale/en_US';
import esEs from 'antd/lib/locale/es_ES';
import ptBr from 'antd/lib/locale/pt_BR';
import { useMemo } from 'react';

const useConfigProvider = () => {
  const locale = useGetLocale();
  const currentLocale = locale();
  const antdLocale = useMemo(() => {
    return currentLocale === 'pt' ? ptBr : currentLocale === 'en' ? enUs : esEs;
  }, [currentLocale]);
  const theme: ThemeConfig = {
    components: {
      Layout: {
        bodyBg: 'var(--primary-background-color)',
      },
    },
  };

  return { antdLocale, theme };
};

export default useConfigProvider;
